// extracted by mini-css-extract-plugin
export default {"h500":"CdC3A","h400":"KLKQ7","h300":"WLWeq","h350":"Cng7p","h200":"AK6E5","h100":"_6RWAW","b400":"_4CdlI","b300":"_9ZxHQ","b200":"Rpme5","b100":"sUd27"};